export function getDocId(conversationId: string): string {
  return conversationId.replace('CONVERSATION-', '');
}
